import React, { useMemo, useState } from 'react';
import { useGetOrdersQuery } from '@epi-api/orders/loadOrdersApi';
import { CardOrderDetails } from '@epi-models/pages/Reports';

type DateState = string | Date | null;

export const useOrders = () => {
  const [page, setPage] = useState(1);
  const [cardType, setCardType] = useState<string>('');
  const [showCalendar, setShowCalendar] = useState(false);
  const [timePeriodType, setTimePeriodType] = useState<string>();
  const [from, setFrom] = useState<DateState>(null);
  const [to, setTo] = useState<DateState>(null);

  const { data, isLoading, isFetching, isError } = useGetOrdersQuery(
    {
      page,
      cardType,
      from: formatDate(from),
      to: formatDate(to),
      abortController: null
    },
    { skip: false }
  );

  const orders = useMemo<CardOrderDetails[]>(() => {
    if (!data?.items) return [];

    return data.items.map((item, idx) => ({
      ...item,
      tooltipLabel: createTooltipLabel(item),
      transactionLabel: createTransactionStatusLabel(item),
      tableRowKey: `${item.orderDate}_${idx}`
    }));
  }, [data]);

  const totalPages = data?.totalPages ?? 0;

  return {
    orders,
    page,
    setPage,
    totalPages,
    isLoading,
    isFetching,
    isError,
    showCalendar,
    setShowCalendar,
    timePeriodType,
    setTimePeriodType,
    from,
    to,
    cardType,
    setCardType,
    setFrom,
    setTo
  };
};

const formatDate = (val: string | Date | null): string =>
  val ? new Date(val).toISOString() : '';

const createTooltipLabel = (item: CardOrderDetails): string =>
  `containers.deposit_money.card_orders_tab.order_tooltip.${item.cardOrderStatus}`;

const createTransactionStatusLabel = (item: CardOrderDetails): string =>
  `containers.deposit_money.card_orders_tab.order_status.${item.cardOrderStatus}`;
